export default __webpack_public_path__ + "static/media/folder_white.1cd3d6ec.svg";